import { UserRole } from "@joonapp/web-shared"
import { useEffect, useState } from "react"

import { QUERY_KEYS } from "../../constants"
import { queryClient } from "../../util/queryClient"
import useCareTeam from "../care/useCareTeam"

const useKeepTryingToLoadCoach = () => {
  const [isLoading, setIsLoading] = useState(true)
  const { firstCoach } = useCareTeam()

  useEffect(() => {
    // If we already have a coach, no need to poll
    if (firstCoach) {
      setIsLoading(false)
      return
    }

    let pollInterval: NodeJS.Timeout
    let maxTimeout: NodeJS.Timeout

    const startPolling = () => {
      // Start polling every 2 seconds until we get a coach
      pollInterval = setInterval(async () => {
        await queryClient.invalidateQueries([QUERY_KEYS.CARE_TEAM])

        // Check if we now have a coach after the refetch
        const updatedCareTeam = queryClient.getQueryData<{
          profiles: Array<{ role: UserRole }>
        }>([QUERY_KEYS.CARE_TEAM])

        if (
          updatedCareTeam?.profiles?.find(
            (profile) => profile.role === UserRole.COACH
          )
        ) {
          clearInterval(pollInterval)
          setIsLoading(false)
        }
      }, 2000)

      // Set a maximum timeout of 30 seconds to prevent infinite polling
      maxTimeout = setTimeout(() => {
        clearInterval(pollInterval)
        setIsLoading(false)
      }, 30000)
    }

    startPolling()

    // Cleanup function
    return () => {
      if (pollInterval) clearInterval(pollInterval)
      if (maxTimeout) clearTimeout(maxTimeout)
    }
  }, [firstCoach])

  return { isLoading, firstCoach }
}

export default useKeepTryingToLoadCoach
